/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Represents the type of approval for a module version
 */
export type ModuleVersionApprovalType = (typeof ModuleVersionApprovalType)[keyof typeof ModuleVersionApprovalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleVersionApprovalType = {
  new_version: 'new_version',
  replace_version: 'replace_version',
  publish_initial: 'publish_initial',
  offer_upgrade: 'offer_upgrade',
} as const;
